/* Iceberg-ui */
import { Flex } from '@auviknetworks/iceberg-ui';

/* MUI */
import { Box, Checkbox, FormControlLabel } from '@mui/material';

/* React */
import React from 'react';

/*  NPM  */
import { Controller, useFormContext } from 'react-hook-form';

export const FormCheckbox = ({
    disabled,
    readOnly,
    inputProps = {},
    name,
    required,
    label
}) => {
    const { control, formState } = useFormContext();
    const { errors } = formState;
    const errorState = errors[name];
    const errorMessage = errorState?.message;

    return (
        <Flex mb="24px">
            <Controller
                name={name}
                control={control}
                rules={{ required }}
                render={({ field: props }) => (
                    <FormControlLabel
                        {...props}
                        control={
                            <Checkbox
                                checked={props.value}
                                color="primary"
                                inputProps={inputProps}
                                readOnly
                                required={required}
                                disabled={disabled || readOnly}
                                disableRipple={disabled || readOnly}
                                variant="secondary"
                            />
                        }
                        label={
                            <Box
                                as="span"
                                sx={{
                                    color: errorMessage
                                        ? 'text.error'
                                        : 'text.primary'
                                }}
                            >
                                {label}
                            </Box>
                        }
                    />
                )}
            />
        </Flex>
    );
};
